import View from "../View/index.js";
import React from "react";
import { classNames } from "../../utilities/helpers.js";
import s from "./Skeleton.module.css";
const Skeleton = (props) => {
    const { backgroundColor = "neutral-faded", borderRadius = "small", width, height, className, attributes, } = props;
    const rootClassNames = classNames(s.root, className);
    return (React.createElement(View, { backgroundColor: backgroundColor, width: width, height: height, borderRadius: borderRadius, className: rootClassNames, attributes: attributes }));
};
export default Skeleton;
